const baseURL = "https://upwork-database.herokuapp.com";

export default baseURL;